import { Component, Input } from '@angular/core';
import { COLLEGE_RECON_CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {

  progressClass!: string;
  @Input() percentage: number = 0;

  ngOnInit() {
    this.getProgressClass();
  }

  ngOnChanges() {
    this.getProgressClass();
  }

  getProgressClass() {
    this.progressClass = this.percentage > COLLEGE_RECON_CONSTANTS.progressBar.good ? 'progress-good' : this.percentage > COLLEGE_RECON_CONSTANTS.progressBar.medium ? 'progress-medium' : 'progress-low'
  }
}
